var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmall = function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 188 188"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#small_svg__a)",
    transform: "rotate(5 94.04 93.772)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.041,
    cy: 93.772,
    r: 90.25,
    fill: "#E84C15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.041,
    cy: 93.772,
    r: 87.25,
    stroke: "#EFE6CC",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#small_svg__b)",
    d: "M4.125 86.03c-4.35 49.712 32.47 93.541 82.182 97.89 49.711 4.35 93.582-32.42 97.931-82.131 4.349-49.712-32.47-93.541-82.182-97.89C52.345-.451 8.474 36.319 4.125 86.03",
    opacity: 0.3,
    style: {
      mixBlendMode: "hard-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "small_svg__b",
    x1: -111.5,
    x2: -26.668,
    y1: -69,
    y2: 218.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3B3B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4B4B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#656568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#89898B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B7B7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#DBDBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#C5C5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#A1A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#848486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5F5F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#636367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#707074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#878789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#98989A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A5A5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#848487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#38383D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "small_svg__a",
    width: 180.783,
    height: 180.783,
    x: 3.785,
    y: 3.517,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.272,
    dy: 0.272
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_808_53214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_808_53214",
    result: "shape"
  })))));
};
export default SvgSmall;